import React from "react";
import { useTranslation } from "react-i18next";

//CSS
import "./helpButton.css";

export default function HelpButton({ onClick }) {
  const { t } = useTranslation();

  return (
    <button
      className="help-button"
      onClick={onClick}
      aria-label={t("Show tutorial for this page")}
      title={t("Show tutorial for this page")}
    >
      ?
    </button>
  );
}
